import { FormHelperText } from "@mui/material";
import { SBTranslate } from "i18n";
import { SBBox, SBSelect, SBTypography } from "modules/Commons";
import { ModifierOperationType } from "modules/Forecast/models/modifierOperationType";
import { useContext, useEffect, useState } from "react";
import { TipsContext } from "views/ConfigsView/ConfigTips";
export default (props: ConfigModifierOperationTypeProps) => {
	const { value, onUpdate } = props;
	const tipsContext = useContext(TipsContext);
	const [modifierOperationType, setModifierOperationType] = useState<ModifierOperationType | null>(value ?? null);
	const modifierOperationTypeValues = [
		{ text: SBTranslate("additive"), value: ModifierOperationType.Additive, tipsContext: "" },
		{ text: SBTranslate("multiplicative"), value: ModifierOperationType.Multiplicative, tipsContext: "" }
	];
	const updateModifierOperationType = (value: number) => {
		tipsContext.showTip(modifierOperationTypeValues.find(r => r.value == value)?.tipsContext ?? "");
		setModifierOperationType(value);
	}

	useEffect(() => {
		onUpdate(modifierOperationType);
	}, [modifierOperationType]);

	return (
		<SBBox>
			<SBTypography
				mb={1}
				fontSize="0.75rem"
				fontWeight="500"
				color="gray3.main"
				variant={"body1"}
				textTransform={"uppercase"}>
				{SBTranslate("operation")}
			</SBTypography>
			<SBSelect
				fullWidth
				getText={item => item.text}
				getValue={item => item.value}
				onChange={(event) => updateModifierOperationType(Number(event.target.value))}
				value={modifierOperationType ?? ModifierOperationType.Additive}
				items={modifierOperationTypeValues}
			/>
		</SBBox>
	);
};
interface ConfigModifierOperationTypeProps {
	value: ModifierOperationType | null;
	onUpdate: (v: ModifierOperationType | null) => void;
}